<template>
  <div class="animated fadeIn">
    <b-tabs class="mb-4">
      <b-tab>
        <template #title>
          Search
          <i class="fa fa-plus-circle ml-1" />
        </template>
        <instrument-runner-search
          :selected_instances="selected_instances"
          @updateSelectedInstances="updateSelectedInstances"
        />
      </b-tab>
      <b-tab v-for="(instance, index) in selected_instances" :key="index">
        <template #title>
          <span v-b-tooltip.hover :title="instance.name">
            {{ instance.identifier }}
          </span>
          <i
            v-b-tooltip.hover
            title="Close tab"
            class="fa fa-times-circle ml-1"
            @click="closeInstanceTab(instance.id)"
          />
        </template>
        <instrument-runner-instance-tab :instance="instance" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import InstrumentRunnerInstanceTab from "./InstrumentRunnerInstanceTab";
import InstrumentRunnerSearch from "./InstrumentRunnerSearch";

export default {
  name: "InstrumentRunnerCardstack",
  components: {
    InstrumentRunnerSearch,
    InstrumentRunnerInstanceTab,
  },
  data() {
    return {
      selected_instances: [],
    };
  },
  methods: {
    updateSelectedInstances(instance) {
      const check = this.selected_instances.find(
        ({ id }) => id === instance.id
      );
      this.selected_instances = check
        ? this.selected_instances.filter(({ id }) => id !== instance.id)
        : [...this.selected_instances, instance];
    },
    closeInstanceTab(instance_id) {
      this.selected_instances = this.selected_instances.filter(
        ({ id }) => id !== instance_id
      );
    },
  },
};
</script>
